import { render, staticRenderFns } from "./InputBuscaUsuario.vue?vue&type=template&id=65fc5934&scoped=true"
import script from "./InputBuscaUsuario.vue?vue&type=script&lang=ts"
export * from "./InputBuscaUsuario.vue?vue&type=script&lang=ts"
import style0 from "./InputBuscaUsuario.vue?vue&type=style&index=0&id=65fc5934&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "65fc5934",
  null
  
)

export default component.exports